import { createModule } from '@vue-storefront/core/lib/module'
import { socialLogin } from './store'
import { afterRegistration } from './hooks/afterRegistration'

const SOCIAL_LOGIN_KEY = 'social-login'
export const SocialLogin = createModule({
  key: SOCIAL_LOGIN_KEY,
  store: { modules: [{ key: SOCIAL_LOGIN_KEY, module: socialLogin }] },
  afterRegistration
})
